import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  makeStyles,
  Container,
  CardContent,
  Divider,
  MenuItem,
  Grid,
  InputLabel,
  TextField,
  CardHeader,
  Button,
  Tooltip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { useNavigate } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import VisibilityIcon from '@material-ui/icons/Visibility';
import MaterialTable from 'material-table';
import { useAlert } from 'react-alert';
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import { Formik } from 'formik';
import * as Yup from 'yup';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from '@material-ui/pickers';
import ReactToPrint from 'react-to-print';
import DateFnsUtils from '@date-io/date-fns';
import { LoadingComponent } from 'src/utils/newLoader';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import FactoryItemGatePassPdf from './FactoryItemGatePassPdf';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const screenCode = 'FACTORYITEMREQUESTGATEPASSDETAILS';
export default function FactoryItemRequestGatePassListing(props) {
  const classes = useStyles();
  const [title, setTitle] = useState('Factory Item Request Gate Pass Details');
  const componentRef = useRef([]);
  const [factoryAdjustmentData, setFactoryAdjustmentData] = useState([]);
  const [groups, setGroups] = useState([]);
  const [factories, setFactories] = useState([]);
  const [factoryItems, setFactoryItems] = useState();
  const [routes, setRoutes] = useState();
  const [page, setPage] = useState(0);
  const [IDDataForDefaultLoad, setIsIDDataForDefaultLoad] = useState(null);
  const [fromDate, handleFromDate] = useState(new Date());
  const [toDate, handleToDate] = useState(new Date());
  const [requestList, setAdjustmentList] = useState({
    groupID: '0',
    factoryID: '0',
    routeID: '0',
    requestType: '0',
    statusID: '0'
  });
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupName: '0',
    factoryName: '0'
  });
  const [selectedInvoiceData, setSelectedInvoiceData] = useState([]);
  const [viewDialogOpen, setViewDialogOpen] = useState(false);

  const navigate = useNavigate();

  const alert = useAlert();
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });

  useEffect(() => {
    const IDdata = JSON.parse(
      sessionStorage.getItem('FCT-listing-page-search-parameters-id')
    );
    getPermission(IDdata);
    if (IDdata != null) {
      getSelectedDropdownValuesForReport(IDdata);
    }
  }, []);

  useEffect(() => {
    sessionStorage.removeItem('FCT-listing-page-search-parameters-id');
  }, []);

  useEffect(() => {
    if (IDDataForDefaultLoad != null) {
      GetDetails();
    }
  }, [IDDataForDefaultLoad]);

  useEffect(() => {
    trackPromise(getGroupsForDropdown());
  }, []);

  useEffect(() => {
    trackPromise(getfactoriesForDropDown());
  }, [requestList.groupID]);

  useEffect(() => {
    trackPromise(
      getRoutesByFactoryID());
  }, [requestList.factoryID]);

  async function getPermission(IDdata) {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(
      p => p.permissionCode == 'FACTORYITEMREQUESTGATEPASS'
    );

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(
      p => p.permissionCode == 'GROUPDROPDOWN'
    );
    var isFactoryFilterEnabled = permissions.find(
      p => p.permissionCode == 'FACTORYDROPDOWN'
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
    });

    const isInitialLoad = IDdata === null;
    if (isInitialLoad) {
      setAdjustmentList({
        ...requestList,
        groupID: parseInt(tokenService.getGroupIDFromToken()),
        factoryID: parseInt(tokenService.getFactoryIDFromToken())
      });
    } else {
      setAdjustmentList({
        ...requestList,
        groupID: IDdata.groupID,
        factoryID: IDdata.factoryID,
        routeID: IDdata.routeID,
        requestType: IDdata.requestType,
        statusID: IDdata.statusID,
        factoryItemID: IDdata.factoryItemID
      });
      handleFromDate(IDdata.fromDate);
      handleToDate(IDdata.toDate);
      setPage(IDdata.page);
      setIsIDDataForDefaultLoad(IDdata);
    }
  }

  async function getRoutesByFactoryID() {
    const routeList = await services.getRoutesForDropDown(
      requestList.factoryID
    );
    setRoutes(routeList);
  }

  async function getfactoriesForDropDown() {
    const factory = await services.getfactoriesForDropDown(requestList.groupID);
    setFactories(factory);
  }

  async function getGroupsForDropdown() {
    const groups = await services.getGroupsForDropdown();
    setGroups(groups);
  }

  async function GetDetails() {
    let model = {
      groupID: parseInt(requestList.groupID),
      factoryID: parseInt(requestList.factoryID),
      routeID: parseInt(requestList.routeID),
      factoryItemID: parseInt(requestList.factoryItemID),
      requestType: parseInt(requestList.requestType),
      statusID: parseInt(requestList.statusID),
      startDate: fromDate,
      endDate: toDate
    };
    
    if (IDDataForDefaultLoad == null) {
      getSelectedDropdownValuesForReport(model);
    }
    setIsIDDataForDefaultLoad(null);
    const customerData = await services.GetFactoryItemRequestGatePassDetails(
      model
    );

    if (customerData.statusCode == 'Success' && customerData.data != null) {
      setFactoryAdjustmentData(customerData.data);
      if (customerData.data.length == 0) {
        alert.error('No records to display');
      }
    } else {
      alert.error('Error');
    }
  }

  function getSelectedDropdownValuesForReport(requestList) {
    const selectedGroupName =
      groups && requestList.groupID in groups
        ? groups[requestList.groupID]
        : '--Select Group--';
    const selectedFactoryName =
      factories && requestList.factoryID in factories
        ? factories[requestList.factoryID]
        : '--Select Factory--';

    setSelectedSearchValues({
      ...selectedSearchValues,
      groupName: selectedGroupName,
      factoryName: selectedFactoryName
    });
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value;
    setAdjustmentList({
      ...requestList,
      [e.target.name]: value
    });
    setFactoryAdjustmentData([]);
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    );
  }
  
  function handleClickEdit(invoiceGroupData, setSelectedInvoiceData, setViewDialogOpen) {
    setSelectedInvoiceData(invoiceGroupData?.children || []);
    setViewDialogOpen(true);
  }

  const groupedData = Object.values(
    factoryAdjustmentData.reduce((invoiceList, item) => {
      if (!invoiceList[item.invoiceNumber]) {
        invoiceList[item.invoiceNumber] = {
          ...item,
          children: [item],
          totalAmountforInvoice: item.totalPrice || 0
        };
      } else {
        invoiceList[item.invoiceNumber].children.push(item);
        invoiceList[item.invoiceNumber].totalAmountforInvoice +=
          item.totalPrice || 0;
      }
      return invoiceList;
    }, {})
  );

  const getPageMargins = () => {
    return `@media print {
            @page {
            size: A4 Landscape !important;  
            background-color: white !important;
        }
        body {
            transform-origin: top left;
            background-color: white !important;
        }
    }`;
  };

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title="Factory Item Request Details">
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: requestList.groupID,
              factoryID: requestList.factoryID,
              fromDate: fromDate,
              toDate: toDate
            }}
            validationSchema={Yup.object().shape({
              groupID: Yup.number()
                .required('Group is required')
                .min('1', 'Group is required'),
              factoryID: Yup.number()
                .required('Factory is required')
                .min('1', 'Factory is required'),
              fromDate: Yup.date()
                .required('From date is required')
                .typeError('Invalid date'),
              toDate: Yup.date()
                .required('To date is required')
                .typeError('Invalid date')
            })}
            onSubmit={() => trackPromise(GetDetails())}
            enableReinitialize
          >
            {({ errors, handleSubmit, touched }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader title={cardTitle(title)} />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent style={{ marginBottom: '2rem' }}>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              size="small"
                              onChange={e => handleChange(e)}
                              value={requestList.groupID}
                              variant="outlined"
                              disabled={!permissionList.isGroupFilterEnabled}
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(groups)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(
                                touched.factoryID && errors.factoryID
                              )}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              size="small"
                              onChange={e => handleChange(e)}
                              value={requestList.factoryID}
                              variant="outlined"
                              id="factoryID"
                              disabled={!permissionList.isFactoryFilterEnabled}
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(factories)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel
                              shrink
                              id="fromDate"
                              style={{ marginBottom: '-8px' }}
                            >
                              From Date *
                            </InputLabel>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <KeyboardDatePicker
                                error={Boolean(
                                  touched.fromDate && errors.fromDate
                                )}
                                helperText={touched.fromDate && errors.fromDate}
                                autoOk
                                fullWidth
                                variant="inline"
                                format="dd/MM/yyyy"
                                margin="dense"
                                name="fromDate"
                                id="fromDate"
                                value={fromDate}
                                onChange={e => {
                                  handleFromDate(e);
                                }}
                                KeyboardButtonProps={{
                                  'aria-label': 'change date'
                                }}
                                InputProps={{ readOnly: true }}
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>

                          <Grid item md={3} xs={12}>
                            <InputLabel
                              shrink
                              id="toDate"
                              style={{ marginBottom: '-8px' }}
                            >
                              To Date *
                            </InputLabel>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <KeyboardDatePicker
                                error={Boolean(touched.toDate && errors.toDate)}
                                helperText={touched.toDate && errors.toDate}
                                autoOk
                                fullWidth
                                variant="inline"
                                format="dd/MM/yyyy"
                                margin="dense"
                                name="toDate"
                                id="toDate"
                                value={toDate}
                                onChange={e => {
                                  handleToDate(e);
                                }}
                                KeyboardButtonProps={{
                                  'aria-label': 'change date'
                                }}
                                InputProps={{ readOnly: true }}
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="routeID">
                              Route
                            </InputLabel>
                            <TextField
                              select
                              fullWidth
                              name="routeID"
                              size="small"
                              onChange={e => handleChange(e)}
                              value={requestList.routeID}
                              variant="outlined"
                              id="routeID"
                            >
                              <MenuItem value="0">--Select Route--</MenuItem>
                              {generateDropDownMenu(routes)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="requestType">
                              Source
                            </InputLabel>

                            <TextField
                              select
                              fullWidth
                              name="requestType"
                              size="small"
                              onChange={e => {
                                handleChange(e);
                              }}
                              value={requestList.requestType}
                              variant="outlined"
                              id="requestType"
                            >
                              <MenuItem value={'0'}>--Select Status--</MenuItem>
                              <MenuItem value={'1'}>Mobile Request</MenuItem>
                              <MenuItem value={'2'}>Direct Request</MenuItem>
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="statusID">
                              Status
                            </InputLabel>

                            <TextField
                              select
                              fullWidth
                              name="statusID"
                              size="small"
                              onChange={e => {
                                handleChange(e);
                              }}
                              value={requestList.statusID}
                              variant="outlined"
                              id="statusID"
                            >
                              <MenuItem value={'0'}>--Select Status--</MenuItem>
                              <MenuItem value={'1'}>Pending</MenuItem>
                              <MenuItem value={'2'}>Issue</MenuItem>
                              <MenuItem value={'3'}>Reject</MenuItem>
                              <MenuItem value={'4'}>Send To Deliver</MenuItem>
                            </TextField>
                          </Grid>
                        </Grid>
                        <br />
                        <Grid container justify="flex-end">
                          <Box pr={2}>
                            <Button
                              color="primary"
                              variant="contained"
                              type="submit"
                            >
                              Search
                            </Button>
                          </Box>
                        </Grid>
                      </CardContent>
                      <Box minWidth={1000}>
                        {factoryAdjustmentData.length > 0 ? (
                          <MaterialTable
                            title="Multiple Actions Preview"
                            columns={[
                              {
                                title: 'Invoice Number',
                                field: 'invoiceNumber',
                                render: rowData => rowData.invoiceNumber
                              },
                              {
                                title: 'Created Date',
                                field: 'effectiveDate',
                                render: rowData =>
                                  rowData.effectiveDate.split('T')[0]
                              },
                              {
                                title: 'Issue Date',
                                field: 'issuingDate',
                                render: rowData =>
                                  rowData.issuingDate.split('T')[0]
                              },

                              { title: 'Route', field: 'routeName' },
                              {
                                title: 'Reg Number',
                                field: 'registrationNumber'
                              },
                              { title: 'Name', field: 'fullName' },
                              {
                                title: 'Total Amount',
                                field: 'totalAmountforInvoice',
                                headerStyle: {textAlign: 'center'},
                                cellStyle: { textAlign: 'right', paddingRight: '50px'}, 
                                render: rowData =>
                                  rowData.totalAmountforInvoice? parseFloat(rowData.totalAmountforInvoice).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "-"
                              },
                              {
                                title: 'Source',
                                field: 'requestType',
                                lookup: {
                                  1: 'Mobile Request',
                                  2: 'Direct Request'
                                }
                              },
                              {
                                title: 'Status',
                                field: 'statusID',
                                lookup: {
                                  1: 'Pending',
                                  2: 'Issue',
                                  3: 'Reject',
                                  4: 'Send To Deliver'
                                }
                              },
                              {
                                title: 'PDF',
                                field: 'button',
                                render: rowData => {
                                  const rowNumber =
                                    factoryAdjustmentData.indexOf(rowData) + 1;
                                  return (
                                    <>
                                      <ReactToPrint
                                        documentTitle={
                                          'Factory Item Gate Pass - ' +
                                          rowData.fullName +
                                          ' - (' +
                                          rowData.registrationNumber +
                                          ')'
                                        }
                                        trigger={() => (
                                          <Tooltip title="PDF">
                                            <IconButton aria-label="PDF">
                                              <PictureAsPdfIcon
                                                style={{ color: 'red' }}
                                              />
                                            </IconButton>
                                          </Tooltip>
                                        )}
                                        pageStyle={getPageMargins()}
                                        content={() =>
                                          componentRef.current[
                                            rowData.factoryItemRequestID
                                          ]
                                        }
                                      />
                                      <div hidden={true}>
                                        <FactoryItemGatePassPdf
                                          ref={el =>
                                            (componentRef.current[
                                              rowData.factoryItemRequestID
                                            ] = el)
                                          }
                                          factoryAdjustmentItems={
                                            rowData.children
                                          }
                                          rowNumber={rowNumber}
                                          selectedSearchValues={
                                            selectedSearchValues
                                          }
                                        />
                                      </div>
                                    </>
                                  );
                                }
                              }
                            ]}
                            data={groupedData}
                            options={{
                              exportButton: false,
                              showTitle: false,
                              headerStyle: { textAlign: 'left', height: '1%' },
                              cellStyle: { textAlign: 'left' },
                              columnResizable: false,
                              actionsColumnIndex: -1,
                              pageSize: 5,
                              initialPage: page
                            }}
                            actions={[
                              {
                                icon: () => <VisibilityIcon />,
                                tooltip: 'View',
                                onClick: (event, rowData) =>
                                  handleClickEdit(rowData, setSelectedInvoiceData, setViewDialogOpen)
                              }
                            ]}
                            onChangePage={page => setPage(page)}
                          />
                        ) : null}
                        {selectedInvoiceData?.length > 0 && (
                          <Dialog
                            open={viewDialogOpen}
                            onClose={() => setViewDialogOpen(false)}
                            maxWidth="lg"
                            fullWidth
                          >
                            <DialogTitle>
                              Invoice Details -{' '}
                              {selectedInvoiceData[0]?.invoiceNumber}
                            </DialogTitle>
                            <DialogContent>
                              <Table>
                                <TableHead>
                                  <TableRow>
                                    <TableCell>Created Date</TableCell>
                                    <TableCell>Issue Date</TableCell>
                                    <TableCell>Route</TableCell>
                                    <TableCell>Reg No</TableCell>
                                    <TableCell>Factory Item</TableCell>
                                    <TableCell>Quantity</TableCell>
                                    <TableCell>Amount</TableCell>
                                    <TableCell>No of Installements</TableCell>
                                    <TableCell>Source</TableCell>
                                    <TableCell>Status</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {selectedInvoiceData.map((item, index) => (
                                    <TableRow key={index}>
                                      <TableCell>
                                        {item.effectiveDate.split('T')[0]}
                                      </TableCell>
                                      <TableCell>
                                        {item.issuingDate.split('T')[0]}
                                      </TableCell>
                                      <TableCell>
                                        {item.routeName}
                                        </TableCell>
                                      <TableCell>
                                        {item.registrationNumber}
                                      </TableCell>
                                      <TableCell>
                                        {item.itemName}
                                        </TableCell>
                                      <TableCell>
                                        {item.approvedQuantity}
                                      </TableCell>
                                      <TableCell align={'right'}>
                                        {item.totalPrice? parseFloat(item.totalPrice).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "-"  }
                                      </TableCell>
                                      <TableCell>
                                        {item.noOfInstallments}
                                      </TableCell>
                                      <TableCell>
                                        {item.requestType === 1
                                          ? 'Mobile Request'
                                          : item.requestType === 2
                                          ? 'Direct Request'
                                          : '-'}
                                      </TableCell>
                                      <TableCell>
                                        {item.statusID === 1
                                          ? 'Pending'
                                          : item.statusID === 2
                                          ? 'Issue'
                                          : item.statusID === 3
                                          ? 'Reject'
                                          : item.statusID === 4
                                          ? 'Send To Deliver'
                                          : '-'}
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </DialogContent>
                          </Dialog>
                        )}
                      </Box>
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}
